export default __webpack_public_path__ + "static/media/daha-iyiye.99def0ff.png";